import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from './base.component';
import { ExampleComponent } from './example-component';

/**
 * BaseModule provides the BaseComponent for memory management.
 * This module can be imported in any module that needs to use the BaseComponent.
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ExampleComponent,
    BaseComponent // Import standalone component
  ],
  exports: [
    BaseComponent, // Export standalone component
    ExampleComponent
  ]
})
export class BaseModule { }
